/*
    Settings.js - Settings singleton model
 */

import {Rest, State} from '@embedthis/devcore'

export default new Rest('settings', {
    reset:      { method: 'POST', uri: '/:controller/reset' },
    uploadCert: { method: 'POST', uri: '/:controller/uploadCert' },
}, {
    //  Tunnel when used by CloudKick
    tunnel: 'Settings',
    context: (body) => {
        if (State.config.name == 'CloudKick') {
            body.deviceId = State.context.deviceId
        }
        return body
    }
})
